import { createSlice } from "@reduxjs/toolkit";

const now = new Date();
const today = `${now.getFullYear()}-${(now.getMonth() + 1).toString().padStart(2, '0')}-${now.getDate()}`;
const d = {
    isCod: null,
    subAccountId: '',
    locationId: '',
    from: today,
    to: today,
    riderCode: '',
    riderName: '',
    accountNo: '',
    weightRequired: false
};

const LoadSheetSlice = createSlice({
    name: 'loadSheetData',
    initialState: {
        data: d,
        selectedLocations: [],
        locations: [],
        riders: [],
        grid: []
    },
    reducers: {
        setData: (state, action) => {
            state.data = action.payload.data
        },
        resetData: (state, action) => {
            state.data = d;
            state.setSelectedLocations = [];
        },
        setLocations: (state, action) => {
            state.locations = action.payload.data
        },
        setSelectedLocations: (state, action) => {
            state.selectedLocations = action.payload.data
        },
        setRiders: (state, action) => {
            state.riders = action.payload.data
        },
        setGrid: (state, action) => {
            state.grid = action.payload.data
        },
        updateGrid: (state, action) => {
            const index = action.payload.index;
            const key = action.payload.key;
            const val = action.payload.val;
            state.grid[index][key] = val;
        }
    }
});

export default LoadSheetSlice.reducer;
export const { setData, resetData, setLocations, setSelectedLocations, setRiders, setGrid, updateGrid } = LoadSheetSlice.actions;